module.exports = __webpack_public_path__ + "static/media/25 - Frank Ocean - In My Room.afad76e8.mp3";